import { createWrapper } from 'src/careflow/ph-core/fhir-client/fhir-react/base';

export const DocumentReferenceWrapper = createWrapper('DocumentReference', (documentReference) => ({
  getTitle: () => documentReference?.content?.[0]?.attachment?.title ?? null,
}));
export type WrappedDocumentReference = ReturnType<typeof DocumentReferenceWrapper>;
